export function user(state) {
    return state.user
}

export function userLocation(state) {
    return state.userLocation
}

export function userCoordinates(state) {
    return state.userCoordinates
}

export function userLocationAddress(state) {
    return state.userLocationAddress
}

export function userLocationIsUserCoordinates(state) {
    const userLocation = {
        lon: state.userLocation[0],
        lat: state.userLocation[1]
    }
    return userLocation.lon === state.userCoordinates.lon && userLocation.lat === state.userCoordinates.lat
}

export function openPOIAfterLogin(state) {
    return state.openPOIAfterLogin
}

export function sessionData(state) {
    return state.sessionData
}